import _asyncToGenerator from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useRouter } from 'next/router';
import useSWR, { useSWRConfig } from 'swr';
import { useOauth } from '@peloton/auth';
import { logoutPost } from '@engage/api-v2';
import { AuthFetchers, clearCache } from '@webtv/data-fetch';
import { OAUTH_ORIGIN, PELOTON_PLATFORM } from '@webtv/env';
import { addAction } from '@webtv/error-reporting-v2';
import useOauthEnabled from './useOauthEnabled';
export var LogoutEvent;

(function (LogoutEvent) {
  LogoutEvent["Account"] = "Account";
  LogoutEvent["OauthErrorHandler"] = "OauthErrorHandler";
  LogoutEvent["Timeout"] = "Timeout";
  LogoutEvent["DeclinedAgeConfirmation"] = "DeclinedAgeConfirmation";
  LogoutEvent["DeclineTerms"] = "DeclineTerms";
})(LogoutEvent || (LogoutEvent = {}));

var useLogout = function useLogout(client, eventId) {
  var oauthEnabled = useOauthEnabled();

  var _useOauth = useOauth(),
      oauthLogout = _useOauth.logout;

  var _useSWR = useSWR.apply(void 0, _toConsumableArray(AuthFetchers.CheckSession({}))),
      mutate = _useSWR.mutate;

  var _useSWRConfig = useSWRConfig(),
      cache = _useSWRConfig.cache;

  var router = useRouter(); // We do a legacy logout to clear sessions and an Oauth logout to clear tokens

  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return logoutPost(client, PELOTON_PLATFORM);

          case 3:
            mutate();
            _context.next = 8;
            break;

          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](0);

          case 8:
            // Ideally, these should match, but in cases where isAuthenticated is true even if Oauth is turned off, we should do an Oauth logout just to be safe
            addAction('logout', {
              type: eventId,
              oauthEnabled: oauthEnabled
            });

            if (oauthEnabled) {
              oauthLogout({
                returnTo: "".concat(OAUTH_ORIGIN, "/welcome")
              });
            } else {
              router.push('/welcome');
            }

            clearCache(cache);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 6]]);
  }));
};

export default useLogout;